import { SimulationResult, ModelConfig } from './financialEngine';

export function downloadJson(config: ModelConfig, simulation: SimulationResult, filename = 'real_estate_financial_model.json') {
  const data = {
    exportDate: new Date().toISOString(),
    config,
    simulation
  };
  const jsonStr = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonStr], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function downloadCsv(simulation: SimulationResult, filename = 'real_estate_trajectory_comparison.csv') {
  const trajectory = simulation.trajectory;
  const headers = [
    'Year',
    'Sell_Buy_Home2_Value',
    'Sell_Buy_Home2_Mortgage',
    'Sell_Buy_Equity',
    'Sell_Buy_Liquid_Investments',
    'Sell_Buy_Net_Worth',
    'Keep_Rent_Home1_Value',
    'Keep_Rent_Home1_Mortgage',
    'Keep_Rent_Home2_Value',
    'Keep_Rent_Home2_Mortgage',
    'Keep_Rent_HELOC_Balance',
    'Keep_Rent_Liquid_Investments',
    'Keep_Rent_Net_Worth',
    'Net_Worth_Difference'
  ];

  const rows = trajectory.map((r) => [
    r.year,
    Math.round(r.sellBuy.home2Value),
    Math.round(r.sellBuy.home2MortgageBalance),
    Math.round(r.sellBuy.home2Equity),
    Math.round(r.sellBuy.liquidInvestments),
    Math.round(r.sellBuy.netWorth),
    Math.round(r.keepRent.home1Value),
    Math.round(r.keepRent.home1MortgageBalance),
    Math.round(r.keepRent.home2Value),
    Math.round(r.keepRent.home2MortgageBalance),
    Math.round(r.keepRent.helocBalance),
    Math.round(r.keepRent.liquidInvestments),
    Math.round(r.keepRent.netWorth),
    Math.round(r.netWorthDifference)
  ]);

  const csvContent = [headers.join(','), ...rows.map((e) => e.join(','))].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
